import { IconHome } from '@audius/harmony'

export const HomePageIcon = IconHome
